import React from "react";
import {
  Legend,
  PolarAngleAxis,
  PolarGrid,
  PolarRadiusAxis,
  Radar,
  RadarChart,
  ResponsiveContainer,
  Tooltip
} from "recharts";

const SummaryRadarCard = ({ data, dataKey }) => {
  return (
    <ResponsiveContainer height={400}>
      <RadarChart data={data}>
        <PolarGrid />
        <PolarAngleAxis dataKey={dataKey} />
        <PolarRadiusAxis domain={[0, 100]} angle={70} />
        <Radar
          name="Candidate"
          dataKey="Candidate"
          stroke="#ff6505"
          fill="#ff6505"
          strokeWidth={3}
          fillOpacity={0.1}
        />
        <Legend /> <Tooltip />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default SummaryRadarCard;
